import React from 'react';
import PropTypes from 'prop-types'

const select = (props) => {
	const {
		options,
		selected,
		id,
		update,
		productKey,
	} = props;

	const filterOptions = (value) => {
		const filter = options.filter((option) => { return option.value === value; });
		return filter[0];
	};

	return (
		<div className="D3-sample-cart__select-wrapper select-wrapper">
			<select className="D3-sample-cart__select select" value={selected.value} onChange={(event) => { update(id, productKey, filterOptions(event.target.value)); }}>
				{ options.map((option) => {
					return (
						<option
							key={`option_${option._id}`}
							value={option.value}
							className="D3-sample-cart__option"
						>
							{option.name}
						</option>
					);
				})}
			</select>
		</div>
	);
};

select.propTypes = {
	options: PropTypes.arrayOf(PropTypes.shape({})),
	selected: PropTypes.shape({}),
	id: PropTypes.string.isRequired,
	update: PropTypes.func,
	productKey: PropTypes.string,
};

select.defaultProps = {
	options: [{
		_id: 0,
		value: 'No Options',
		name: 'No Options',
	}],
	selected: {
		_id: 0,
		value: 'No Options',
		name: 'No Options',
	},
	update: () => {},
	productKey: '',
};

export default select;
